/**
 * 获取今日周
 */
export function getWeek(time) {
  let date;
  if (time) {
    date = new Date(time);
  }else {
    date = new Date();
  }
  return date.getDay() === 0 ? 7 : date.getDay();
}
/**
 * 排序 小 <-- 大
 */
export function sort(Arr, item) {
  var min;
  for(let i=0; i<Arr.length; i++){
      for(let j=i; j<Arr.length;j++){
        if(Arr[i][item]>Arr[j][item]){      
          min=Arr[j];
          Arr[j]=Arr[i];
          Arr[i]=min;
        }
      }

  }
}
/**
 * 加0
 */
 export function addZoo(num) {
  if (num <= 9) {
    return "0"+num
  }else {
    return num;
  }
}

/**
 * 检测文件类型
 */
 export function getFlieType(url) { //检测文件类型
  if (url.search(/.*?\.(jpeg|jpg|gif|png|svg|webp|jfif|bmp|dpg)$/gi) !== -1) { //图片
    return 'image';
  }else if (url.search(/.*?\.(mp3)$/gi) !== -1) { //音乐
    return 'radio';
  }else if (url.search(/.*?\.(mp4)$/gi) !== -1) { //视频
    return 'video';
  }else {
    return 'other';
  }
}